import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import formActions from "../../Actions/formActions";
import compensationActions from "../../Actions/compensationActions";

import Card from "../../Components/Card/Card";
import forms from "../../Constants/forms";
import CompensationTicketForm from "../../Components/Settings/Compensation/CompensationTicketForm";
import { CompensationStatus } from "../../Constants/Compensations/compensationStatus";
import CompensationTicketInfo from "../../Components/Settings/Compensation/CompensationTicketInfo";
import ConfirmDeleteModal from "../../Components/Modals/ConfirmDeleteModal/ConfirmDeleteModal";
import Modals from "../../Constants/modals";
import useModal from "../../Hooks/useModal";
import SkynetIcon from "../../Components/Fundamentals/SkynetIcon";
import routes from "../../Constants/routes";

export default function SettingsCompensationEditContainer() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const { isModalOpen, openModal, closeModal } = useModal();

    const isLoading = useSelector(state => state.CommonReducer.dataLoading.compensationTicketForm);
    const isDeleting = useSelector(state => state.CommonReducer.dataLoading.compensationDeletion);
    const form = useSelector(state => state.FormReducer.forms[forms.compensationTicketFormData]);
    const ticket = useSelector(state => state.SettingsReducer.compensationTicket);

    useEffect(() => {
        dispatch(compensationActions.getSelectedTicketForEdit(id));

        return () => {
            dispatch(formActions.cancelFormEditing(forms.compensationTicketFormData));
        }
    }, []);

    const onSaveClick = () => {
        dispatch(formActions.submitForm(form, () => {
            dispatch(compensationActions.saveTicket(id, form, () => onGoBack()));
        }));
    };

    const onGoBack = () => {
        navigate(routes.settingsCompensation);
    };

    const onDeleteClick = () => {
        dispatch(compensationActions.deleteTicket(id, onDeleteSuccess));
    };

    const onDeleteSuccess = () => {
        closeModal();
        onGoBack();
    };

    const handleFieldChange = (field, value) => {
        dispatch(formActions.changeMultiFormField(form, field, value));
    };

    const approvalRequested = ticket?.status === CompensationStatus.ApprovalRequested;
    const isClosed = ticket?.status === CompensationStatus.Closed;

    return (
        <>
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <Card.Header.Title>{t("settingscompensationeditcontainer.title")}</Card.Header.Title>
                        <span className="mb-8">
                            <SkynetIcon icon={'vismaicon-delete'} title={t('common.delete')} onClick={() => openModal(Modals.ConfirmDeleteModal)} />
                        </span>
                    </div>
                </Card.Header>
                <Card.Content isLoading={isLoading}>
                    {ticket && <CompensationTicketInfo ticket={ticket} />}
                    {form && <CompensationTicketForm form={form} onChange={handleFieldChange} isEditable={!isClosed && !approvalRequested} />}
                </Card.Content>
                <Card.Footer>
                    <Card.Footer.Buttons>
                        {!isClosed && (
                            <button type="button" className="btn btn-primary btn-sm" onClick={onSaveClick}>
                                {approvalRequested ? t("common.approve") : t("common.save")}
                            </button>
                        )}
                        <button type="button" className="btn btn-default btn-sm" onClick={onGoBack}>
                            {t("common.cancel")}
                        </button>
                    </Card.Footer.Buttons>
                </Card.Footer>
            </Card>
            {isModalOpen(Modals.ConfirmDeleteModal) && (
                <ConfirmDeleteModal
                    title={t('settingscompensationeditcontainer.compensationdeletemodalheader')}
                    onSubmit={onDeleteClick}
                    isLoading={isDeleting}
                />
            )}
        </>
    );
}